import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <MediaSection />
        <RankingSection />
        <FaqSection />
        <TopicsSection />
        <CardsSection />
        <ContactSection />
        <AppSection />
        <AboutSection />
        <CarouselSection />
        <IndexSection />
        <UpdatesSection />
        <FeaturesSection />
      </main>
      <Footer />
    </div>
  );
}